import { render, staticRenderFns } from "./auth-form-login.vue?vue&type=template&id=c4c8cf52&scoped=true"
import script from "./auth-form-login.vue?vue&type=script&lang=js"
export * from "./auth-form-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c8cf52",
  null
  
)

export default component.exports